const state = {
  onboarding_screen: [],
  onboarding_screen_id: [],
  slide_screen: [],
};

export default state;
